// Third-party
import React from 'react';
import cropperjs from 'cropperjs';

// Components
import { ImageUpload } from '../image-upload';
import { CancelButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Redux
import { cropUserImg, cropBrandingLogo } from '@/redux/modules/auth';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { ReduxState } from '@/redux/modules/types';
import { connect } from 'react-redux';

// Types
import User from '@/types/user';
import Nullable from '@/types/nullable';

type StateProps = {
  user?: User | null;
};

type DispatchProps = {
  cropUserImg: (imgUrl: string, fileType: string, dimensions: cropperjs.Data) => Promise<string>;
  cropBrandingLogo: (imgUrl: string, fileType: string, dimensions: cropperjs.Data) => Promise<string>;
};

type Props = StateProps &
  DispatchProps & {
    isUploadCoBrandingLogo?: boolean;
    show: boolean;
    targetImgUrl?: Nullable<string>;
    onCancel: () => void;
    i18nPath: string;
  };

const UploadImageModal = ({ user, onCancel, targetImgUrl, i18nPath, show, isUploadCoBrandingLogo, cropBrandingLogo, cropUserImg }: Props) => {
  if (!user) {
    return null;
  }

  const imageUploadConfigs = isUploadCoBrandingLogo
    ? { errorMessageKey: 'SAVE_LOGO_ERROR', uploadHandler: cropBrandingLogo }
    : { errorMessageKey: 'SAVE_IMG_ERROR', uploadHandler: cropUserImg };

  return (
    <Modal show={show} className="upload-image-modal" onHide={onCancel} dialogClassName="modal-dialog-centered">
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id={`${i18nPath}.Title`} />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex flex-column">
        <ImageUpload
          onSave={onCancel}
          aspectRatio={1}
          targetImg={targetImgUrl}
          labelPrefix={i18nPath}
          onUpload={imageUploadConfigs.uploadHandler}
          errorKey={imageUploadConfigs.errorMessageKey}
        />
      </Modal.Body>

      <Modal.Footer className="justify-content-end">
        <CancelButton onClick={onCancel} />
      </Modal.Footer>
    </Modal>
  );
};
const mapStateToProps = (state: ReduxState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, {
  cropUserImg,
  cropBrandingLogo,
})(UploadImageModal);
